import tw from 'tailwind-styled-components'
import {getLabelDefault, getLabelDisabled} from './classes/label-class'
import {getDefault, getDisabled} from './classes/main-class'
import {getSupportDefault, getSupportDisabled} from './classes/support-class'
import {TwInputType} from './types'
import {getIconSize} from './utils'

export const TwInput = tw.input<TwInputType>`
  all-unset
  relative
  rounded-4
  transition
  duration-100
  ease-linear
  border-solid
  active:outline
  focus:outline
  placeholder-placeholder
  box-border
  text-sm-regular
  flex-1
  cursor-text
  bg-transparent
  focus:bg-transparent
  ${p =>
    p.$disabled
      ? getDisabled(p.$hasError, p.$isSuccess)
      : getDefault(p.$hasError, p.$isSuccess)}
  ${p => getIconSize(p.$leftIcon, p.$rightIcon)}
  ${p => {
    if (p.$height) {
      return `h-${p.$height}`
    }
    return p.$size === '40' ? 'h-40' : p.$size === '24' ? 'h-24' : 'h-32'
  }}
  ${p =>
    p.$borders
      ? `outline-2 active:outline-2 focus:outline-2 border-1 active:border-1 focus:border-1`
      : `outline-0 active:outline-0 focus:outline-0 border-0 active:border-0 focus:border-0`}
  ${p => {
    const {$rounded = '4'} = p
    return $rounded === '4' ? `rounded-4` : `rounded-8`
  }}
`

export const TwWrap = tw.div`
  flex
  gap-8
  items-start
  flex-col
`

export const TwLabel = tw.div<TwInputType>`
  plain-text-semibold
  truncate
  ${p =>
    p.$disabled ? getLabelDisabled(p.$hasError) : getLabelDefault(p.$hasError)}
`

export const TwSupport = tw.div<TwInputType>`
  micro-semibold
  truncate
  ${p =>
    p.$disabled
      ? getSupportDisabled(p.$hasError)
      : getSupportDefault(p.$hasError)}
`

export const TwIconLeft = tw.div`
  absolute
  h-full
  flex
  items-center
  left-12
  z-20
  text-secondary
`

export const TwIconRight = tw.div`
  absolute
  h-full
  flex
  items-center
  right-12
  z-20
  text-secondary
`

export const TwContainer = tw.div<{$size: '40' | '32' | '24'}>`
  relative
  flex
  flex-1
  w-full
  bg-transparent
  focus:bg-transparent
  ${p => (p.$size === '40' ? 'h-40' : p.$size === '24' ? 'h-24' : 'h-32')}
`
